/**
 * XIconFocus
 */
class XIconFocus {

  constructor(icon = null, hover = null) {
    this.activate = icon;
    this.hover = hover;
  }

  setHover(icon) {
    this.hover = icon;
  }

  setActivate(icon) {
    this.activate = icon;
  }

}

export {
  XIconFocus,
};
